<template>
  <div
    :class="$store.getters['main/getBackgroundTone'](evenOdd)"
    :style="paddingCalculator"
  >
    <div class="offer-card container">
      <div class="offer-card__title font-38 tbc-medium">
        {{ _.get(contentData, "conf.header.title") }}
      </div>
      <div class="offer-card__teaser font-18">
        {{ _.get(contentData, "conf.header.teaser") }}
      </div>
      <transition name="toggleContent" mode="out-in">
        <div class="offer-card__list" v-if="!waiting">
          <offer-card-with-image
            :key="index"
            :contentData="contentData"
            :offer="offer"
            v-for="(offer, index) in offers"
          />
        </div>
        <div key="empty" class="empty-div" v-else></div>
      </transition>
      <transition name="toggleContent" mode="out-in">
        <div class="empty-result-text" v-if="!_.size(offers)">
          {{ $fn.tr("nothing was found !") }}
        </div>
      </transition>

      <transition name="toggleContent" mode="out-in">
        <div
          class="offer-card__list more-items"
          key="offer"
          v-if="moreLength > 6"
        >
          <offer-card-with-image
            :key="index"
            :contentData="contentData"
            :offer="offer"
            v-for="(offer, index) in loadedMoreOffers"
          />
        </div>
      </transition>
      <button
        key="button"
        class="more tbc-medium font-16 uppercase"
        v-if="_.size(offersData) > 5 && moreLength < _.size(offersData)"
        @click="moreLength = moreLength + 6"
      >
        {{ $fn.tr("LOAD MORE") }}
      </button>
    </div>
  </div>
</template>

<script>
import paddingCalculator from "@/mixins/paddingMixin";
import OfferCardWithImage from "./OfferCardWithImage.vue";
import OffersSlider from "./OffersSlider.vue";
import moment from "moment";
export default {
  components: { OfferCardWithImage, OffersSlider },
  mixins: [paddingCalculator],
  props: ["contentData", "evenOdd"],

  data() {
    return {
      pTopDesktop: 144,
      pBottomDesktop: 144,
      more: false,
      moreLength: 6,
      waiting: false,
      offersData: null,
      tagSearchData: null
    };
  },
  watch: {
    "$store.state.otherModules.tagTypes": {
      immediate: true,
      handler(val) {
        if (_.size(val) && val[0] !== 0) {
          this.offersData =
            _.get(this.contentData, "data.list").filter(offer =>
              offer.offers_cagegory.includes(val[0])
            ) || [];
          this.tagSearchData = this.offersData;
        } else {
          this.offersData = _.get(this.contentData, "data.list");
          this.tagSearchData = this.offersData;
        }
      }
    },
    "$store.state.otherModules.searchVal": {
      handler(val) {
        const searchWord = val.toLowerCase();
        const clonedData = [...this.offersData];
        if (searchWord.length > 2) {
          setTimeout(() => {
            this.offersData = this.tagSearchData.filter(
              offer =>
                offer.title.toLowerCase().includes(searchWord) ||
                offer.teaser.toLowerCase().includes(searchWord)
            );
          }, 400);
        }
        if (!val) {
          this.offersData = this.tagSearchData;
        }
        // console.log(val, "val", this.offersData, "this.offersData", clonedData);
        // this.offersData =
      }
    },
    "$store.state.otherModules.offerSearchDate": {
      handler(val) {
        if (!val) {
          this.offersData = this.tagSearchData;
          return;
        }
        const startDate = new Date(val.start);
        const endDate = new Date(val.end);

        this.offersData = this.offersData.filter(offer => {
          const endOfferDate = offer.endDate ? new Date(offer.endDate) : null;
          const startOfferDate = offer.startDate
            ? new Date(offer.startDate)
            : null;

          if (endOfferDate && startOfferDate) {
            return (
              startDate.getTime() <= endOfferDate.getTime() &&
              endDate.getTime() >= endOfferDate.getTime()
            );
          } else {
            return false;
          }
        });
      }
    }
  },
  computed: {
    offers() {
      let blogList = this.offersData;
      this.changeWaitingAnimation();
      return blogList?.slice(0, 6);
    },
    loadedMoreOffers() {
      let blogList = this.offersData;
      return blogList?.slice(6, this.moreLength);
    }
  },
  methods: {
    changeWaitingAnimation() {
      this.waiting = true;
      setTimeout(() => {
        this.waiting = false;
      }, 500);
    }
  }
};
</script>

<style lang="scss">
.empty-div {
  min-height: 50vh;
}
.empty-result-text {
  padding: 20px 0 50px;
  font-size: 34px;
}
.more-items {
  margin-top: 30px;
}
.more {
  display: flex;
  padding-top: 24px;
  padding-bottom: 24px;
  padding-left: 30px;
  padding-right: 30px;
  justify-content: center;
  align-items: center;
  background-color: #364756;
  border-radius: 6px;
  color: #ffffff;
  margin: 0 auto;
  margin-top: calc(60px - 30px);
  transition: 0.4s ease;
}
.more:hover {
  background: var(--tbc-blue);
  color: #364756;
}
.offer-card {
  &__teaser {
    line-height: 27px;
    max-width: 840px;
    margin-top: 12px;
    margin-bottom: 52px;
    @media (max-width: 1023px) {
      max-width: unset;
    }
  }
  &__list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0px, 1fr));
    grid-gap: 30px;
    @media (max-width: 767px) {
      grid-template-columns: repeat(1, minmax(0px, 1fr));
    }
  }
  &__title {
    @media (max-width: 767px) {
      font-size: 24px;
    }
  }
}
</style>
